import moment from 'moment-timezone';
import { getInvoiceColumnVisibility } from '@/utilities/invoiceColumnHelper';
const enablePageBreak = false; // toggle this to true if pdf generator (currently html2pdf library is used) breaks pages correctly

var generateTemplate = function (invoice, lineItems, customer) {
  var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var isLeapYear = invoice.year % 100 === 0 ? invoice.year % 400 === 0 : invoice.year % 4 === 0;
  if (isLeapYear) daysInMonth[1] = 29;

  // get grand totals including its children if any
  var grandTotals = getGrandTotals(lineItems, customer);

  // determine if tenant still has an active trial
  const d = getTenantTime(customer.timeZone,-24)
  let todayMidnightUnixTime = new Date(d.dt).setHours(0,0,0,0)
  let trialExpMidnightUnixTime = new Date(customer.trialExpDate).setHours(0,0,0,0)
  let isTrialExpired =  trialExpMidnightUnixTime < todayMidnightUnixTime
  const isInTrial = !isTrialExpired || customer.accountPremiumStatus.includes('trial');
  if(isInTrial) tenantFlatMonthlyBillingAmount = 0;
  var tenantFlatMonthlyBillingAmount = invoice?.flatMonthlyBillingAmount && !isInTrial ? invoice?.flatMonthlyBillingAmount : 0;
  var tenantFlatMonthlyBillingLabel = invoice?.flatMonthlyBillingLabel ? invoice?.flatMonthlyBillingLabel : 'Flat Total'
   
   

    //Get amount charged including its children if any
    var amoutCharged = getAmountCharged(invoice, customer)
    
    //This will include children amount as well if any
    grandTotals.variableTotal =
    grandTotals.standardCostExt +
    grandTotals.bundleCostExt +
    grandTotals.performanceCostExt +
    grandTotals.rosteringCostExt +
    grandTotals.staffCostExt +
    grandTotals.vehiclesCostExt;

  //This will include children amount as well if any
  grandTotals.invoiceSubTotal = grandTotals.variableTotal + tenantFlatMonthlyBillingAmount;

  var fixedDiscount = invoice.discountFixed && !isInTrial ? invoice.discountFixed : 0;
  var percentDiscount = invoice.discountPercent ? (invoice.discountPercent / 100) * (grandTotals.invoiceSubTotal - fixedDiscount) : 0;
  var invoiceTotal = grandTotals.invoiceSubTotal - fixedDiscount - percentDiscount;
  grandTotals.invoiceTotal = invoiceTotal.toFixed(2);

  if (!invoice.discountFixedLabel) {
    invoice.discountFixedLabel = '';
  } else {
    invoice.discountFixedLabel = '('+ invoice.discountFixedLabel +') '
  }

  if (!invoice.discountPercentLabel) {
    invoice.discountPercentLabel = '';
  } else {
    invoice.discountPercentLabel = '('+ invoice.discountPercentLabel + ' - ' + invoice.discountPercent+'%) '
  }

  // Get column visibility configuration
  const columnConfig = getInvoiceColumnVisibility(customer, lineItems);
  
  // Check if any line items have trial status
  const hasTrialItems = lineItems.some(item => item.isTrial);
  //Bill To company name will be parent company name for children otherwise it will be their own company name
  const billToCompanyName = customer.parentCompanyName ? customer.parentCompanyName : customer.companyName ? customer.companyName : ''

  var html = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice - ${customer.companyName || 'Hera Solutions'}</title>
    <style>
        :root {
            --primary-color: #0066cc;
            --text-primary: #1a1a1a;
            --text-secondary: #555;
            --text-muted: #666;
            --border-light: #f1f3f4;
            --border-medium: #dee2e6;
            --bg-light: #f8f9fa;
            --bg-alt: #fafbfc;
            --shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        
        * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }
        
        body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            line-height: 1.5;
            color: var(--text-primary);
            background: #fff;
            margin: 0;
            padding: 0;
            font-size: 14px;
        }
        
        .invoice-container {
            max-width: 900px;
            margin: 0 auto;
            background: #fff;
        }
        
        .invoice-header {
            padding: 0.5rem;
            display: grid;
            grid-template-columns: auto 1fr 1fr;
            gap: 1rem;
            align-items: center;
        }
        
        .company-info h1 {
            font-size: 1.75rem;
            font-weight: 700;
            margin-bottom: 0.5rem;
            color: var(--text-primary);
        }
        
        .company-info p {
            font-size: 0.875rem;
            color: var(--text-muted);
            margin: 0.25rem 0;
        }
        
        .company-info a {
            color: var(--primary-color);
            text-decoration: none;
            font-weight: 500;
        }
        
        .bill-to-info h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: var(--text-primary);
            margin-bottom: 0.5rem;
        }
        
        .bill-to-info p {
            margin: 0.25rem 0;
            color: var(--text-secondary);
            font-size: 0.875rem;
        }
        
        .logo img {
            height: 80px;
            width: auto;
        }
        

        
        .invoice-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: .5rem;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        
        .invoice-table th {
            background: #fafbfc;
            padding: .5rem 1rem;
            text-align: left;
            font-weight: 500;
            font-size: 0.8rem;
            color: var(--text-secondary);
            border-bottom: 1px solid var(--border-light);
            text-transform: uppercase;
        }
        
        .invoice-table td {
            padding: 0.3rem 1rem;
            border-bottom: 1px solid var(--border-light);
        }
        
        .invoice-table tbody tr:nth-child(even) {
            background: var(--bg-alt);
        }
        
        .invoice-table .text-right {
            text-align: right;
        }
        
        .invoice-table .text-center {
            text-align: center;
        }
        
        .totals-row {
            border-top: 3px solid var(--primary-color) !important;
            font-weight: 600;
        }
        
        .totals-row td {
            padding: .5rem 1rem;
            font-style: italic;
            color: var(--text-primary);
        }
        
        .summary-section {
            padding: 1rem;
            border-radius: 8px;
            margin-left: auto;
            width: 335px;
        }
        
        .summary-row {
            display: grid;
            grid-template-columns: 200px 1fr;
            gap: 20px;
            align-items: center;
            padding: 0.1rem 0;
            //border-bottom: .5px solid var(--border-light);
        }
        
        .summary-row:last-child {
            border-bottom: none;
        }
        
        .summary-value {
            text-align: right;
        }
        
        .summary-row.total {
            background: var(--primary-color);
            color: white;
            padding: .5rem ;
            font-weight: 700;
            font-size: 1.125rem;
            border-radius: 6px;
        }
        
        .summary-label {
            color: var(--text-secondary);
            font-weight: 500;
        }
        
        .summary-value {
            font-weight: 600;
            color: var(--text-primary);
            font-size: 1rem;
            text-align: right;
        }
        
        .summary-row.total .summary-label,
        .summary-row.total .summary-value {
            color: white;
        }
        
        .trial-badge {
            color: var(--primary-color);
            font-weight: 500;
            font-size: 0.75rem;
        }
        
        .inactive-cell {
            color: #ccc;
            font-style: italic;
        }
        
        @media print {
            * {
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
            }
            
            body {
                margin: 0;
                padding: 0.5rem;
                font-size: 12px;
                line-height: 1.2;
            }
            
            .invoice-header {
                page-break-inside: avoid;
                page-break-after: avoid;
            }
            
            .invoice-table {
                page-break-inside: auto;
            }
            
            .invoice-table thead {
                page-break-inside: avoid;
                page-break-after: avoid;
            }
            
            .invoice-table tbody tr {
                page-break-inside: avoid;
            }
            
            .totals-row {
                page-break-inside: avoid;
                page-break-before: avoid;
            }
            
            .summary-section {
                page-break-inside: avoid;
                page-break-before: avoid;
            }
            
            .invoice-container {
                max-width: none;
                margin: 0;
                box-shadow: none;
                border-radius: 0;
                overflow: visible;
            }
            
            .invoice-header {
                padding: 0.5rem 0;
            }
            
            .invoice-table {
                font-size: 10px;
                margin-bottom: 1rem;
                box-shadow: none;
            }
            
            .invoice-table th {
                padding: 0.3rem 1rem;
            }
            
            .invoice-table td {
                padding: 0.3rem 1rem;
            }
            
            .invoice-table tbody tr:nth-child(even) {
                background: transparent !important;
            }
            
            .totals-row td {
                padding: 0.3rem 1rem;
            }
            
            .summary-section {
                padding: 0.5rem;
                border: none;
            }
            
            .summary-row {
                padding: 0.2rem 0;
            }
            
            .summary-row.total {
                padding: 0.3rem;
                margin: 0;
            }
        }
        
        @media (max-width: 768px) {
            body {
                padding: 0.5rem;
            }
            
            .header-content {
                grid-template-columns: 1fr;
                text-align: center;
            }
            
            .invoice-meta {
                grid-template-columns: 1fr;
            }
            
            .invoice-table {
                font-size: 0.75rem;
            }
            
            .invoice-table th,
            .invoice-table td {
                background: #A3B087;
                padding: 0.5rem 0.25rem;
            }
        }
    </style>
</head>
<body>
    <div class="invoice-container">
        <div class="invoice-header">
            <div class="logo">
                <img src='https://irp.cdn-website.com/dda4e527/dms3rep/multi/HeraLogoVertical.png' alt="Hera Solutions Logo"> 
            </div>
            <div class="company-info">
                <h1>Hera Solutions, Inc</h1>
                <p>4062 Peachtree Rd NE</p>
                <p>STE A556</p>
                <p>Atlanta, GA 30319</p>
                <p><a href="https://www.hera.app/" target="_blank">www.hera.app</a></p>
            </div>
            <div class="bill-to-info">
                <h3>Bill To</h3>
                <p><strong>${billToCompanyName} - ${customer.shortCode ? customer.shortCode : ''}</strong></p>
                <p><strong>Billing Period:</strong> ${invoice.year}-${String(parseInt(invoice.month) + 1).padStart(2, '0')}</p>
                <p><strong>Charged To:</strong> ${invoice.cardLastFourCharged ? '****' + invoice.cardLastFourCharged : '—'}</p>
            </div>
        </div>

        <div class="invoice-body">`;

            

  const parentTenantInvoiceLineItems = {
    invoice, lineItems, customer
  }
  const tenantAndChildrenInvoiceLineItems = customer?.children?.length>0 ? [parentTenantInvoiceLineItems,...customer.children]:[parentTenantInvoiceLineItems]
  
  for (let index = 0; index < tenantAndChildrenInvoiceLineItems.length; index++) {
    const currentCustomer = tenantAndChildrenInvoiceLineItems[index].customer
    const currentLineItems = tenantAndChildrenInvoiceLineItems[index].lineItems
    const currentInvoice = tenantAndChildrenInvoiceLineItems[index].invoice

    const companyName = `<p style="font-weight: bold; font-size: 24px; margin-bottom: 8px; ${ (enablePageBreak && index > 0) ? 'break-before: page;':''}">
    ${currentCustomer.companyName ? currentCustomer.companyName : ''}
    </p>`
    html += companyName

    const table = `
    <table class="invoice-table">
                <thead>
                    <tr>
                        <th style="width: 12%;" class="text-left">Day</th>
                        <th style="width: 12%;" class="text-center">Active Staff</th>
                        ${columnConfig.visibleColumns.includes('standard') ? '<th style="width: 12%;" class="text-right">Standard</th>' : ''}
                        ${columnConfig.visibleColumns.includes('heraSubscription') ? `<th style="width: 12%;" class="text-right">${columnConfig.bundleColumnName}</th>` : ''}
                        ${columnConfig.visibleColumns.includes('performance') ? '<th style="width: 12%;" class="text-right">Performance</th>' : ''}
                        ${columnConfig.visibleColumns.includes('rostering') ? '<th style="width: 12%;" class="text-right">Rostering</th>' : ''}
                        ${columnConfig.visibleColumns.includes('staff') ? '<th style="width: 12%;" class="text-right">Staff</th>' : ''}
                        ${columnConfig.visibleColumns.includes('vehicles') ? '<th style="width: 12%;" class="text-right">Vehicles</th>' : ''}
                        <th style="width: 12%;" class="text-right">Total</th>
                    </tr>
                </thead>
                <tbody>`;
    
    html += table

  var i = 0;
  for (const item of currentLineItems) {
    var month = String(parseInt(item.month) + 1).padStart(2, '0');
    var day = String(item.day).padStart(2, '0');
    html += `
                <tr>
                    <td class="text-left">${month}/${day}${item.isTrial ? '&nbsp;&nbsp;<span style="color: #0066cc; font-weight: 500; font-size: 0.7rem;">Trial</span>' : ''}</td>
                    <td class="text-center">${item.activeStaff}</td>
                    ${columnConfig.visibleColumns.includes('standard') ? `<td class="text-right">${formatCurrency(item.standardCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('heraSubscription') ? `<td class="text-right">${formatCurrency(item.bundleCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('performance') ? `<td class="text-right">${formatCurrency(item.performanceCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('rostering') ? `<td class="text-right">${formatCurrency(item.rosteringCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('staff') ? `<td class="text-right">${formatCurrency(item.staffCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('vehicles') ? `<td class="text-right">${formatCurrency(item.vehiclesCostExt.toFixed(2))}</td>` : ''}
                    <td class="text-right">${formatCurrency(item.variableTotal.toFixed(2))}</td>
                </tr>`;
    i = item.day;
  }
  
  i++;
  for (i; i <= daysInMonth[currentInvoice.month]; i++) {
    var month = String(parseInt(currentInvoice.month) + 1).padStart(2, '0');
    var day = String(i).padStart(2, '0');
    html += `
                <tr>
                    <td class="text-left">${month}/${day}</td>
                    <td class="text-right" style="color: #ccc;">—</td>
                    ${columnConfig.visibleColumns.includes('standard') ? '<td class="text-right" style="color: #ccc;">—</td>' : ''}
                    ${columnConfig.visibleColumns.includes('heraSubscription') ? '<td class="text-right" style="color: #ccc;">—</td>' : ''}
                    ${columnConfig.visibleColumns.includes('performance') ? '<td class="text-right" style="color: #ccc;">—</td>' : ''}
                    ${columnConfig.visibleColumns.includes('rostering') ? '<td class="text-right" style="color: #ccc;">—</td>' : ''}
                    ${columnConfig.visibleColumns.includes('staff') ? '<td class="text-right" style="color: #ccc;">—</td>' : ''}
                    ${columnConfig.visibleColumns.includes('vehicles') ? '<td class="text-right" style="color: #ccc;">—</td>' : ''}
                    <td class="text-right" style="color: #ccc;">—</td>
                </tr>`;
  }

  html += `
                <tr class="totals-row">
                    <td colspan="2" style="text-align: left; font-weight: 600;">Subtotal:</td>
                    ${columnConfig.visibleColumns.includes('standard') ? `<td class="text-right">${formatCurrency(grandTotals.standardCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('heraSubscription') ? `<td class="text-right">${formatCurrency(grandTotals.bundleCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('performance') ? `<td class="text-right">${formatCurrency(grandTotals.performanceCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('rostering') ? `<td class="text-right">${formatCurrency(grandTotals.rosteringCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('staff') ? `<td class="text-right">${formatCurrency(grandTotals.staffCostExt.toFixed(2))}</td>` : ''}
                    ${columnConfig.visibleColumns.includes('vehicles') ? `<td class="text-right">${formatCurrency(grandTotals.vehiclesCostExt.toFixed(2))}</td>` : ''}
                    <td class="text-right">${formatCurrency(grandTotals.variableTotal.toFixed(2))}</td>
                </tr>
            </tbody>
        </table>`;
  if(index === tenantAndChildrenInvoiceLineItems.length-1){

           html +=  `<section class="summary-section">
                <div class="summary-row">
                    <span class="summary-label">Total:</span>
                    <span class="summary-value">${formatCurrency(grandTotals.variableTotal.toFixed(2))}</span>
                </div>`;

  if (tenantFlatMonthlyBillingAmount > 0) {
    html += `
                <div class="summary-row">
                    <span class="summary-label">${tenantFlatMonthlyBillingLabel}:</span>
                    <span class="summary-value">${formatCurrency(tenantFlatMonthlyBillingAmount.toFixed(2))}</span>
                </div>`;
  }

  html += `
                <div class="summary-row">
                    <span class="summary-label">Invoice Sub Total:</span>
                    <span class="summary-value">${formatCurrency(grandTotals.invoiceSubTotal.toFixed(2))}</span>
                </div>`;

  if (fixedDiscount) {
    html += `
                <div class="summary-row">
                    <span class="summary-label">${invoice.discountFixedLabel}Discount:</span>
                    <span class="summary-value">-${formatCurrency(fixedDiscount.toFixed(2))}</span>
                </div>`;
  }

  if (percentDiscount) {
    html += `
                <div class="summary-row">
                    <span class="summary-label">${invoice.discountPercentLabel}Discount:</span>
                    <span class="summary-value">-${formatCurrency(percentDiscount.toFixed(2))}</span>
                </div>`;
  }

  html += `
                <div class="summary-row">
                    <span class="summary-label">Invoice Total:</span>
                    <span class="summary-value">${formatCurrency(grandTotals.invoiceTotal)}</span>
                </div>`;

  if (invoice.status=='Paid'){
      html += `
                <div class="summary-row">
                    <span class="summary-label">Amount Charged:</span>
                    <span class="summary-value">${formatCurrency(amoutCharged.toFixed(2))}</span>
                </div>
                <div class="summary-row">
                    <span class="summary-label">Balance:</span>
                    <span class="summary-value">$0.00</span>
                </div>`;
  }

  if (invoice.status=='Pending' || invoice.status=='Payment Error' || invoice.status=='Finalized'){
    html += `
                <div class="summary-row">
                    <span class="summary-label">Amount Charged:</span>
                    <span class="summary-value">$0.00</span>
                </div>
                <div class="summary-row">
                    <span class="summary-label">Balance:</span>
                    <span class="summary-value">${formatCurrency(grandTotals.invoiceTotal)}</span>
                </div>`;
  }

  html += `
            </section>`;
}
  }
        html += `</div>
    </div>
</body>
</html>`;

  return html;
};

function getTenantTime(timeZone, offsetHours=0){
  console.log("Tenant Timezone:", timeZone);
  if (!!moment.tz.zone(timeZone)){
    const utc = offsetHours >= 0 ? moment.utc().add(Math.abs(offsetHours), 'hours'):moment.utc().subtract(Math.abs(offsetHours), 'hours');
    const isoUtcDate = utc.format("YYYY-MM-DDTHH:mm:ssZZ");
    console.log("Utc    Time: ",isoUtcDate);
    const dt = utc.clone().tz(timeZone);
    const isoDate = dt.format("YYYY-MM-DDTHH:mm:ssZZ");
    console.log("Tenant Time: ",isoDate);
    const year = dt.year()
    const month = dt.month()
    const day = dt.date()
    //Month is 0 index but this function is 1 index, so adding 1 to month
    const numOfDays = new Date(year, month + 1, 0).getDate();
    return {dt:dt, day:day, month:month, year:year, numOfDays: numOfDays, isoDate:isoDate, utcDt: utc, isoUtcDate: isoUtcDate};
  }
  else{
    console.log("Tenant has invalid timezone value");
    return null;
  }
}

function getGrandTotals(parentLineItems, customer){
  
  let lineItems = parentLineItems

  if(customer?.children?.length>0){
    //If children exist then add their line items too to calculate accumulative grand totals
    customer.children.forEach(child=>{
      lineItems = [...lineItems, ...child.lineItems]
    })
  }

  // calculate grand totals
  var grandTotals = lineItems.reduce((accumulator, item) => ({
    standardCostExt: accumulator.standardCostExt + item.standardCostExt,
    bundleCostExt: accumulator.bundleCostExt + item.bundleCostExt,
    performanceCostExt: accumulator.performanceCostExt + item.performanceCostExt,
    rosteringCostExt: accumulator.rosteringCostExt + item.rosteringCostExt,
    staffCostExt: accumulator.staffCostExt + item.staffCostExt,
    vehiclesCostExt: accumulator.vehiclesCostExt + item.vehiclesCostExt,
  }));

  return grandTotals; 
}

function getAmountCharged(parentInvoice, customer){
  let amountCharged = parentInvoice?.paidByCustomerAmount ? parentInvoice?.paidByCustomerAmount : 0;
  
  if(customer?.children?.length>0){
    //If children exist then add their amount as well
    customer.children.forEach(child=>{
      amountCharged += child?.invoice?.paidByCustomerAmount ? child?.invoice?.paidByCustomerAmount : 0;
    })
  }
  
  return amountCharged
}

function formatCurrency(amount) {
  return new Intl.NumberFormat(navigator.language, {
    style: "currency",
    currency: 'USD',
  }).format(amount);
}

export default generateTemplate;
